import React, { Component } from "react";
import { file, ReactNode } from "react";
import Button from "../../components/CustomButtons/Button.jsx";
import { useSpring, animated } from "react-spring";
import PropTypes from "prop-types";
import logo from "../../images/dut.png";
import dutylogo from "../../images/dutylogo.png";
import addphoto from "../../images/addphoto.png";
import check from "../../images/check.png";
import "./files.css";
import { Link } from "react-router-dom";
import errorImg from "../../images/error.png";
import Assignment from "@material-ui/core/SvgIcon/SvgIcon";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Image from "material-ui-image";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import TextField from "@material-ui/core/TextField";
import DialogContentText from "@material-ui/core/DialogContentText";

import { red } from "@material-ui/core/colors";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import GridList from "@material-ui/core/GridList";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import GridListTile from "@material-ui/core/GridListTile";
import Checkbox from "@material-ui/core/Checkbox";
import Container from "@material-ui/core/Container";

// material-ui icons
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Add from "@material-ui/icons/Add";
import CloudUpload from "@material-ui/icons/CloudUpload";
import FolderOpen from "@material-ui/icons/FolderOpen";
import ChatBubbleOutline from "@material-ui/icons/ChatBubbleOutline";
import {
  CloudDownloadOutlined,
  Delete, FileCopyOutlined, FolderOpenOutlined,
  FontDownload, PersonAdd
} from "@material-ui/icons";
import FavoriteBorderOutlined from "@material-ui/icons/FavoriteBorderOutlined";
import Check from "@material-ui/icons/Check";
import Remove from "@material-ui/icons/Remove";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

// core components
import Card from "components/Card/Card.jsx";

import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import product1 from "assets/img/product1.jpg";
import product2 from "assets/img/product2.jpg";
import product3 from "assets/img/product3.jpg";
import ExtendedTables from "../Tables/ExtendedTables";
import dutyConnect from "../../images/DutyConnect.jpeg";
import dutyPlanner from "../../images/DutyPlanner.jpeg";
import dutyControl from "../../images/DutyControl.jpeg";
import color from "@material-ui/core/colors/deepPurple";

class Files extends Component {
  constructor(props) {
    super(props);
    const { classes } = this.props;
    this.files = {
      files: [],
      obj: {}
    };
    this.folder = {
      folder: [],
      obj2: {}
    };
    this.state = {
      checked: [],
      successFile: false,
      successFolder: false,
      openFolder: false,
      handleClose2: true,
      img: "",
      titulo: "",
      carpeta: "",
      imagePreviewUrl: addphoto,
      modalFile: false,
      modalErrorStatus: false,
      openFile: false,
      backButton: false,
      data: [
        [this.createFolder(true), this.Navigation("Duty Connect"), "-", "10/05/2019", this.createFolderButtons()],
        [this.createFolder(true), this.Navigation("Duty Planner"), "-", "10/05/2019", this.createFolderButtons()],
        [this.createFolder(true), this.Navigation("Duty Control"), "-", "10/05/2019", this.createFolderButtons()],
        [
          this.createFile(),
          "Presentación de producto.png",
          "375,11KB",
          "10/05/2019",
          this.createSimpleButtons()
        ],
        [
          this.createFile(),
          "Todos los beneficios.png",
          "375,11KB",
          "10/05/2019",
          this.createSimpleButtons()
        ],
        [
          this.createFile(),
          "Implementación instantanea.png",
          "375,11KB",
          "10/05/2019",
          this.createSimpleButtons()
        ]
      ],
      currentData: [],
    };
    this.handleToggle = this.handleToggle.bind(this);
  }
  handleToggle(value) {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked
    });
  }
  componentDidMount() {
    this.setState({ currentData: this.state.data })
  }
  clearData() {
    this.setState({ currentData: this.state.data, backButton: false })
  }
  changeDataTable = (flag) => {
    let files = [];
    if (flag) {
      files = [
        [
          this.createFile(),
          "Implementación instantanea.png",
          "375,11KB",
          "10/05/2019",
          this.createSimpleButtons()
        ],
        [
          this.createFile(),
          "Presentación de producto.png",
          "375,11KB",
          "10/05/2019",
          this.createSimpleButtons()
        ],
        [
          this.createFile(),
          "Todos los beneficios.png",
          "375,11KB",
          "10/05/2019",
          this.createSimpleButtons()
        ]
      ];
    }
    this.setState({ currentData: files, backButton: true })
  };
  Navigation = (campo) => {
    const { classes } = this.props;
    return [
      { color: "github" }
    ].map((prop, key) => {
      return (
        <Button
          color={prop.color}
          simple
          className={classes.actionButton}
          key={key}
          onClick={() => {
            this.changeDataTable(true);
          }}
        >
          <Typography style={{ fontSize: 12 }}>
            { campo }
          </Typography>
        </Button>
      );
    })
  };
  createFolderButtons = () => {
    const { classes } = this.props;
    return [
      { color: "info", icon: CloudDownloadOutlined },
      { color: "info", icon: Edit },
      { color: "info", icon: Delete }
    ].map((prop, key) => {
      return (
        <Button
          color={prop.color}
          simple
          className={classes.actionButton}
          key={key}
        >
          <prop.icon className={classes.icon} />
        </Button>
      );
    })
  };
  createSimpleButtons = () => {
    const { classes } = this.props;
    return [
      { color: "info", icon: CloudDownloadOutlined },
      { color: "info", icon: Delete }
    ].map((prop, key) => {
      return (
        <Button
          color={prop.color}
          simple
          className={classes.actionButton}
          key={key}
        >
          <prop.icon className={classes.icon} />
        </Button>
      );
    })
  };
  createFolder = (flag) => {
    const { classes } = this.props;
    return [
      { color: "info", icon: FolderOpenOutlined }
    ].map((prop, key) => {
      return (
        <Button
          color={prop.color}
          simple
          className={classes.actionButton}
          key={key}
          onClick={() => {
            this.changeDataTable(flag);
          }}
        >
          <prop.icon className={classes.icon} />
        </Button>
      );
    })
  };
  createFile = () => {
    const { classes } = this.props;
    return [
      { color: "info", icon: FileCopyOutlined }
    ].map((prop, key) => {
      return (
        <Button
          color={prop.color}
          simple
          className={classes.actionButton}
          key={key}
        >
          <prop.icon className={classes.icon} />
        </Button>
      );
    });
  };
  _pickImage = () => {
    return (
      <div className="picture-container">
        <div className="picnov picture">
          <Image
            src={this.state.imagePreviewUrl}
            onClick={() => console.log('onClick')}
            errorIcon={<FileCopyOutlined style={{ fontSize: 70, color: "#000" }}></FileCopyOutlined>}
          />
          <input type="file" onChange={e => this.handleImageChange(e)} />
        </div>
      </div>
    );
  };
  handleImageChange = e => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    if (file) {
      reader.onloadend = () => {
        this.setState({
          file: file,
          imagePreviewUrl: reader.result
        });
      };
      reader.readAsDataURL(file);
    }
  };
  modalError = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modalErrorStatus}
        open={this.state.modalErrorStatus}
        onClose={() => {
          this.setState({ modalErrorStatus: false });
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Card
          style={{
            margin: "auto",
            marginTop: 100,
            width: 350,
            height: 320,
            alignItems: "center"
          }}
        >
          <CardContent className="textCardNov2"></CardContent>
          <CardMedia
            style={{
              height: "50%",
              width: "50%",
              margin: "auto",
              backgroundSize: "contain"
            }}
            className="textCardNov2"
            image={errorImg}
            title="error"
          ></CardMedia>
          <CardContent
            className="textCardNov2"
            style={{
              textAlign: "center !important",
              alignContent: "center !important"
            }}
          >
            <Typography
              className="titCard"
              style={{ textAlign: "center" }}
              gutterBottom
              variant="h5"
              component="h2"
            >
              Error
            </Typography>
            <Typography
              variant="txtCardNov"
              color="textSecondary"
              component="p"
            >
              Debes completar todos los campos.
            </Typography>
            <Button
              className="btn2"
              onClick={() => {
                this.setState({ modalErrorStatus: false });
              }}
            >
              <Typography className="btnNewNov2">ACEPTAR</Typography>
            </Button>
          </CardContent>
        </Card>
      </Modal>
    );
  };
  _tabla = () => {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              {this.state.backButton ?
                <Button
                  simple
                  style={{ position: "absolute", left: 0, zIndex: 9 }}
                  onClick={() => {
                    this.clearData();
                  }}
                >
                  <ArrowBack className="btn1icon" />
                </Button>
                : null}
              <Table
                tableHead={["", "Nombre", "Tamaño", "Fecha", "Acción"]}
                tableData={
                  this.state.currentData
                }
                customCellClasses={[
                  classes.left,
                  classes.left,
                  classes.right,
                  classes.right,
                  classes.right
                ]}
                customClassesForCells={[0, 1, 2, 3, 4]}
                customHeadCellClasses={[
                  classes.left,
                  classes.left,
                  classes.right,
                  classes.right,
                  classes.right
                ]}
                customHeadClassesForCells={[0, 1, 2, 3, 4]}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };
  setModalSuccessFile = prop => {
    this.setState({ successFile: prop });
  };
  setModalSuccessFolder = prop => {
    this.setState({ successFolder: prop });
  };
  setModalFile = prop => {
    this.setState({ openFile: prop });
  };
  setModalFolder = prop => {
    this.setState({ openFolder: prop });
  };
  getCurrentDate() {
    let newDate = new Date();
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${date}/${month < 10 ? `0${month}` : `${month}`}/${year}`;
  }
  _newFile = () => {
    const { file } = this.state;
    if (!file) {
      this.setState({ modalErrorStatus: true });
    } else {
      const archivo =
        [
          this.createFile(),
          file.name,
          bytesToSize(file.size),
          this.getCurrentDate(),
          this.createSimpleButtons()
        ];
      this.setState(
        {
          currentData: [...this.state.currentData, archivo],
          file: null,
          imagePreviewUrl: addphoto
        },
        () => {
          this.setModalFile(false);
          this.setModalSuccessFile(true);
        });
    }
  };
  _newFolder = () => {
    const { carpeta } = this.state;
    if (!carpeta) {
      this.setState({ modalErrorStatus: true });
    } else {
      const folder = [
        this.createFolder(),
        this.Navigation(carpeta),
        "-",
        this.getCurrentDate(),
        this.createFolderButtons()];
      this.setState(
        {
          currentData: [folder, ...this.state.currentData],
          carpeta: ""
        },
        () => {
          this.setModalFolder(false);
          this.setModalSuccessFolder(true);
        });
    }
  };
  _modalSuccessFile = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modal}
        open={this.state.successFile}
        onClose={() => {
          this.setModalSuccessFile(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <div>
          <Card item xs={12}
            className="cardModal"
            style={{
              width: "50%",
              height: "60%",
              alignItems: "center"
            }}
          >
            <CardContent>
              <img src={check} style={{ height: "50%", width: "100%", margin: "auto" }} />
            </CardContent>
            {/*<CardMedia
              style={{ height: "50%", width: "50%", margin: "auto" }}
              className="textCardNov"
              image={check}
              title="check"
            />*/}
            <CardContent className="textCardNov2">
              <Typography
                className="titCard"
                style={{ textAlign: "center" }}
                gutterBottom
                variant="h5"
                component="h2"
              >
                Archivo cargado con éxito
              </Typography>
              <Typography
                variant="txtCardNov"
                color="textSecondary"
                component="p"
              >
                Has subido un nuevo Archivo que podrán ver todos los usuarios
              </Typography>
              <Button
                className="btn2"
                onClick={() => {
                  this.setModalSuccessFile(false);
                }}
              >
                <Typography className="btnNewNov2">ACEPTAR</Typography>
              </Button>
            </CardContent>
          </Card>
        </div>
      </Modal>
    );
  };
  _modalSuccessFolder = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modal}
        open={this.state.successFolder}
        onClose={() => {
          this.setModalSuccessFolder(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <div>
          <Card
            className="cardModal"
            style={{
              width: "50%",
              height: "60%",
              alignItems: "center"
            }}
          >
            <CardContent>
              <img src={check} style={{ height: "50%", width: "100%", margin: "auto" }} />
            </CardContent>
            {/*            <CardMedia
                style={{ height: "50%", width: "50%", margin: "auto" }}
                className="textCardNov"
                image={check}
                title="check"
            />*/}
            <CardContent className="textCardNov2">
              <Typography
                className="titCard"
                style={{ textAlign: "center" }}
                gutterBottom
                variant="h5"
                component="h2"
              >
                Carpeta creada con éxito
              </Typography>
              <Typography
                variant="txtCardNov"
                color="textSecondary"
                component="p"
              >
                Has creado una nueva Carpeta que podrán ver todos los usuarios
              </Typography>
              <Button
                className="btn2"
                onClick={() => {
                  this.setModalSuccessFolder(false);
                }}
              >
                <Typography className="btnNewNov2">ACEPTAR</Typography>
              </Button>
            </CardContent>
          </Card>
        </div>
      </Modal>
    );
  };
  _modalFolder = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modal}
        open={this.state.openFolder}
        style={{ overflow: "scroll", alignContent: "center" }}
        onClose={() => {
          this.setModalFolder(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <div>
          <Card
            className="cardModal"
            style={{
              paddingTop: 20,
              width: window.innerWidth < 600 ? "70%" : "50%"
            }}
          >
            <CardContent className="textCardModal">
              <Typography gutterBottom variant="h5" component="h2">
                Nueva Carpeta
              </Typography>
              <div style={{ width: "100%" }}>
                <TextField
                  id="standard-name"
                  style={{
                    width: "100%",
                    marginTop: 0,
                    marginBottom: 0,
                    fontSize: 12,
                    height: "20%"
                  }}
                  placeholder="Ingrese nombre"
                  className={useStyles.textField}
                  value={this.state.carpeta}
                  inputProps={{
                    onChange: e => {
                      this.setState({ carpeta: e.target.value });
                    },
                    type: "text"
                  }}
                  margin="normal"
                />
              </div>
            </CardContent>
            <CardContent className="buttomNewNod">
              <div
                className="buttonsHed"
                style={{ width: "100%", display: "contents" }}
              >
                <Button
                  style={{ width: "50%" }}
                  className="btn1"
                  onClick={() => {
                    this.setModalFolder(false);
                  }}
                >
                  <Typography className="btnNewNov1">CANCELAR</Typography>
                </Button>
                <Button
                  style={{ width: "50%" }}
                  className="btn2"
                  onClick={() => {
                    this._newFolder();
                  }}
                >
                  <Typography className="btnNewNov2">ENVIAR</Typography>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </Modal>
    );
  };
  _modalFile = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modal}
        open={this.state.openFile}
        style={{ overflow: "scroll", alignContent: "center" }}
        onClose={() => {
          this.setModalFile(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <div>
          <Card
            className="cardModal"
            style={{
              margin: "auto",
              marginTop: 30,
              width: window.innerWidth < 600 ? "70%" : "50%"
            }}
          >
            {this._pickImage()}
            <CardContent className="textCardModal">
              <div>
                {this.state.file ? 'Nombre: ' + this.state.file.name : ''}
              </div>
              <div>
                {this.state.file ? 'Tamaño: ' + bytesToSize(this.state.file.size) : ''}
              </div>
            </CardContent>
            <CardContent className="buttomNewNod">
              <div
                className="buttonsHed"
                style={{ width: "100%", display: "contents" }}
              >
                <Button
                  style={{ width: "50%" }}
                  className="btn1"
                  onClick={() => {
                    this.setModalFile(false);
                  }}
                >
                  <Typography className="btnNewNov1">CANCELAR</Typography>
                </Button>
                <Button
                  style={{ width: "50%" }}
                  className="btn2"
                  onClick={() => {
                    this._newFile();
                  }}
                >
                  <Typography className="btnNewNov2">ENVIAR</Typography>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </Modal>
    );
  };
  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <Header />
        <Toolbar />
        <div
          style={{
            paddingTop: window.innerWidth < 600 ? 70 : 10,
            paddingBottom: 20
          }}
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="center"
            spacing={3}
            style={{ width: "100%" }}
          >
            <Grid item xs={12} sm={6}>
              <Typography className="novTit">Archivos</Typography>
            </Grid>
            <Grid
              className="titMod2"
              item
              xs={12}
              sm={6}
              style={{ width: "100%" }}
            >
              <div className="divbtn3">
                <Button
                  className="btn3"
                  onClick={() => {
                    this.setModalFolder(true);
                  }}
                >
                  <FolderOpen className="btn3icon" />
                  <Typography className="txtb3">Crear Carpeta</Typography>
                </Button>
              </div>
              <div className="divbtn3">
                <Button
                  className="btn3"
                  onClick={() => {
                    this.setModalFile(true);
                  }}
                >
                  <Add className="btn3icon" />
                  <Typography className="txtb3">Subir Archivo</Typography>
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
        {this._tabla()}
        <div style={{ height: "100%" }}>
          {this._modalFile()}
          {this._modalFolder()}
          {this._modalSuccessFile()}
          {this._modalSuccessFolder()}
          {this.modalError()}
        </div>
      </React.Fragment>
    );
  }
}
function Header(props) {
  return (
    <ElevationScroll {...props}>
      <AppBar>
        <Toolbar
          style={{ backgroundColor: "#fff", paddingLeft: 0, paddingRight: 0 }}
        >
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              sm={6}
              style={{ padding: 20, paddingBottom: 10 }}
            >
              <div>
                <Link to="/">
                  <img src={logo} className="App-logo" alt="logo" />
                </Link>
              </div>
            </Grid>
            <Grid
              container
              direction="row"
              justify="space-around"
              alignItems="center"
              xs={12}
              sm={6}
              style={{
                padding: 10,
                flexWrap: "nowrap",
                justifyContent: "center",
                marginBottom: 10
              }}
            >
              <div style={{ width: "40%", marginRight: 5 }}>
                <Link to="/">
                  <Button
                    className="btn1"
                    style={{
                      width: "100%",
                      padding: 0,
                      margin: 0,
                      backgroundColor: "#fff"
                    }}
                  >
                    <ArrowBack className="btn1icon" style={{}} />
                    <Typography className="txtb1" style={{ fontSize: 12 }}>
                      Seguir probando
                    </Typography>
                  </Button>
                </Link>
              </div>
              <div style={{ width: "40%", marginLeft: 5 }}>
                <Link to="/finish">
                  <Button
                    className="btn2"
                    style={{
                      width: "100%",
                      padding: 0,
                      margin: 0,
                      backgroundColor: "#F50027"
                    }}
                  >
                    <Typography className="txtb2">
                      Probar 14 días gratis{" "}
                    </Typography>
                  </Button>
                </Link>
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </ElevationScroll>
  );
}
function bytesToSize(bytes) {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes == 0) return "0 Byte";
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}
function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined
  });
  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0
  });
}
const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    }
  });
  return (
    <animated.div
      ref={ref}
      style={[
        style,
        { flexDirection: "row", flex: 1, justifyContent: "center" }
      ]}
      {...other}
    >
      {children}
    </animated.div>
  );
});
ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func
};
const useStyles = makeStyles(theme => ({
  card: {
    width: "65%",
    marginBottom: 15,
    height: 300
  },
  media: {
    height: 300,
    paddingTop: "56.25%" // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: red[500]
  },
  modal: {
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // flexDirection: 'row',
    // flex: 1,
    justifyContent: "center",
    overflow: "scroll"
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  textField: {
    width: "100%",
    marginTop: 0,
    fontSize: 15
  },
  /*  customCardContentClass: {
    paddingLeft: "0",
    paddingRight: "0"
  },*/
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
}));

Files.propTypes = {
  classes: PropTypes.object
};

export default withStyles(extendedTablesStyle)(Files);
